module.exports = __webpack_public_path__ + "static/media/7.9b493632.svg";